export default "__VITE_ASSET__CKcJGD9y__"